
import { defineComponent, ref } from "vue";
import Modal from "../../../shared/components/Modal.vue";
import Input from "../../../shared/components/Input.vue";
import Alert from "../../../shared/components/Alert.vue";
import Spinner from "../../../shared/components/Spinner.vue";
import useVuelidate from "@vuelidate/core";
import { SocialMediaType, useRegister, useLogin, useMobileKeyboard } from "@kunsten/core";
import { email, required, minLength } from "@vuelidate/validators";
import { useRouter } from "vue-router";

export default defineComponent({
    name: "RegisterPopup",
    components: { Modal, Input, Alert, Spinner },
    data() {
        return {
            email: "",
            password: "",
            confirmPassword: "",
        };
    },
    validations() {
        return {
            email: { required, email },
            password: { required, minLength: minLength(8) },
            confirmPassword: {
                required,
                sameAs: this.repeatPassword,
            },
        };
    },
    methods: {
        repeatPassword(password: string) {
            return password === this.password;
        },
    },
    setup() {
        const v$ = useVuelidate();
        const router = useRouter();
        const backendError = ref("");
        const loading = ref(false);
        const { startSocialMediaLogin } = useLogin();
        const { register } = useRegister();
        const { toggleModalKeyboardClass } = useMobileKeyboard();

        const socialMediaLogin = (socialMedia: SocialMediaType) => {
            startSocialMediaLogin(socialMedia);
        };

        const submit = (email: string, password: string): void => {
            backendError.value = "";
            loading.value = true;
            register(email, password)
                .then(() => {
                    router.push({ name: "LandingPage", query: { view: "login" } });
                    loading.value = false;
                })
                .catch((err) => {
                    if (err.response) {
                        backendError.value = err.response.data.message;
                    } else {
                        backendError.value = err.message;
                    }
                    loading.value = false;
                });
        };

        return {
            v$,
            submit,
            socialMediaLogin,
            toggleModalKeyboardClass,
            backendError,
            loading,
        };
    },
});
